import { render, staticRenderFns } from "./FiltrarRelatorioRastreabilidade.vue?vue&type=template&id=ecc71b60&scoped=true&lang=pug"
import script from "./FiltrarRelatorioRastreabilidade.vue?vue&type=script&lang=js"
export * from "./FiltrarRelatorioRastreabilidade.vue?vue&type=script&lang=js"
import style0 from "./FiltrarRelatorioRastreabilidade.vue?vue&type=style&index=0&id=ecc71b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc71b60",
  null
  
)

export default component.exports